import moment from 'moment';
import * as produitConf from '@/configuration/produitConf';
import genererModeReglement from './genererModeReglement';
import genererDelaiReglement from './genererDelaiReglement';
import genererDelaiReglementDetail from './genererDelaiReglementDetail';

function genererCategorieVente(produits) {
  let count = 0;
  Object.values(produits).forEach(produit => {
    if (produit.length > 0) count += 1;
  });
  if (count > 1) return produitConf.CATEGORIE_DIVERS;
  if (produits.panneauxLc.length > 0) return produitConf.CATEGORIE_UNITAIRE;
  if (produits.panneauxNumeriques.length > 0) return produitConf.CATEGORIE_ECRAN_NUMERIQUE;
  if (produits.reseauxLc.length > 0) return produitConf.CATEGORIE_REGROUPEMENT_LC;
  if (produits.reseauxNumeriques.length > 0) return produitConf.CATEGORIE_REGROUPEMENT_NUMERIQUE;
  if (produits.reseauxTempo.length > 0) return produitConf.CATEGORIE_REGROUPEMENT;
  return produitConf.CATEGORIE_LIBRE;
}

export default function genererDevisCommande(
  type,
  sousType,
  societe,
  agenceId,
  theme,
  dateValidite,
  commercialId,
  produits) {
  const modeReglement = genererModeReglement();
  const delaiReglement = genererDelaiReglement();
  const delaiReglementDetail = genererDelaiReglementDetail();
  const categorieVente = genererCategorieVente(produits);
  return {
    type: type,
    echeanciers: [],
    sousType: sousType,
    dateDevisCommande: moment().format('YYYY-MM-DD'),
    dateValidite: dateValidite ? moment(dateValidite).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
    commercialId: commercialId,
    assistantId: null,
    theme: theme,
    id: null,
    commentaireInterne: null,
    commentaire: null,
    intervenants: [],
    lignesCommande: [],
    penalite: true,
    escompte: true,
    recouvrement: true,
    montantHt: 0,
    montantTva: 0,
    montantTtc: 0,
    companyId: 1,
    factureGroupee: true,
    repartitionsTva: [],
    echeancierPaiement: [],
    modeReglementId: null,
    modeReglement: modeReglement,
    delaiReglementId: null,
    delaiReglement: delaiReglement,
    delaiReglementDetail: delaiReglementDetail,
    categorieVente,
    renouvelable: false,
    reconductible: false,
    dateRenouvellement: null,
    adresseLivraison: societe ? societe.adresseLivraison : null,
    masqueRemise: false,
    agenceId: agenceId,
    societeId: societe.id,
    role: 'Regie',
  };
}



// WEBPACK FOOTER //
// ./src/services/devis/genererDevisCommande.js